"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useBoolean } from "@chakra-ui/react";
import { Input, InputVariant } from "../Input";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
import { IconButton } from "../IconButton";
import { ButtonVariant } from "../Button";
const PasswordInput = forwardRef((_a, ref) => {
    var { disabled, variant } = _a, rest = __rest(_a, ["disabled", "variant"]);
    const [isPasswordVisible, setIsPasswordVisible] = useBoolean(false);
    const passwordLabel = `${isPasswordVisible ? "Hide" : "Show"} password`;
    return (_jsx(Input, Object.assign({ ref: ref, type: isPasswordVisible ? "text" : "password", optionalElement: _jsx(IconButton, { minW: "6", size: "md", icon: _jsx(SvgSpriteConsumer, { svgId: isPasswordVisible ? "eyeCloseFilled24" : "eyeOpenFilled24", size: 24 }), variant: ButtonVariant.ICON, "aria-label": passwordLabel, "aria-pressed": isPasswordVisible, onClick: setIsPasswordVisible.toggle, isDisabled: disabled || variant === InputVariant.READONLY }), variant: variant, disabled: disabled }, rest)));
});
PasswordInput.displayName = "PasswordInput";
export default PasswordInput;
//# sourceMappingURL=PasswordInput.js.map